import { EditOrderDetail } from './order-detail.interface';
import {
  initialStateEditFlorderDetail,
  initialStateOrderDetail,
} from 'app/core/store/edit-florder-detail/florder-detail.model';

export const initialStateEditOrderDetail: EditOrderDetail = Object.assign({}, initialStateEditFlorderDetail, {
  orderDetail: initialStateOrderDetail,
  loadedEpp: null,
  maxEpp: null,
  recurrenceDates: null,
});
